<template>
  <div class="news-tb">
    <a
        class="news-tb__link"
        :class="{'news-tb__link--active': active === 'News'}"
        href="#"
        @click.prevent="clickHandle('News')"
    >
      Новости
    </a>
    <a
        class="news-tb__link"
        :class="{'news-tb__link--active': active === 'Ads'}"
        href="#"
        @click.prevent="clickHandle('Ads')"
    >
      Объявления
    </a>
  </div>
</template>

<script>
export default {
  name: "NewsTabBar",
  props: {
    value: {
      type: String,
      default: 'News'
    },
  },
  data() {
    return {
      active: this.value
    }
  },
  methods: {
    clickHandle(val) {
      this.active = val;
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
.news-tb {
  width: 100%;
  max-width: 420px;
  border: 1px solid #eee;
  border-radius: 2px;
  display: inline-flex;
  &__link {
    padding: 8.5px 15px;
    flex-grow: 1;
    color: var(--md-theme-tab-bar-color) !important;
    text-align: center;
  }
  &__link:first-child {
    border-bottom-left-radius: 2px;
    border-top-left-radius: 2px;
  }
  &__link:last-child {
    border-bottom-right-radius: 2px;
    border-top-right-radius: 2px;
  }
  &__link--active {
    background-color: var(--md-theme-tab-bar-color) !important;
    color: #ffffff !important;
  }
}
</style>
